import { z } from "zod";
import {
    FEEDBACK_TEXT,
    SupportedFeedbackTextLocales,
} from "../../apps/utils/validationHelpers";

export const NewsletterSignupSchema = (
    locale: SupportedFeedbackTextLocales = "no",
) => {
    const feedback = FEEDBACK_TEXT(locale);

    return z.object({
        email: z.email({ message: feedback.INVALID })
                .trim()
                .toLowerCase()
                .min(1, { message: feedback.REQUIRED }),
        birthday: z.union([
            z.date(),
            z.string()
              .trim()
              .min(1, { message: feedback.REQUIRED })
              .pipe(z.coerce.date()),
        ]),
        gender: z.string().min(1, { message: feedback.REQUIRED }),
        acceptsTerms: z.boolean().refine((value) => value === true, {
            message: feedback.CONSENT_REQUIRED,
        }),
    });
};
